import { useGetProductName } from '@ms/yammer-hooks/dist/rebranding';
import { useCurrentLocale, useCurrentLocaleDirection } from '@ms/yammer-i18n-react/dist/hooks';
import { useSetRTL } from '@ms/yammer-web-core-ui/dist/util/useSetRTL';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { useGetFaviconPath } from '../hooks';

/**
 * Component that updates the language, text direction and shortcut icon of the `<html>` tag.
 */
const AppDocumentHeadOverrides: FC = () => {
  const lang = useCurrentLocale();
  const dir = useCurrentLocaleDirection();
  useSetRTL(dir);
  const productName = useGetProductName();
  const faviconPath = useGetFaviconPath();

  return (
    <Helmet defaultTitle={productName} titleTemplate={`${productName} - %s`} defer={false}>
      <html lang={lang} dir={dir} />
      <link rel="shortcut icon" href={faviconPath} />
    </Helmet>
  );
};

export default AppDocumentHeadOverrides;
